module.exports = __webpack_public_path__ + "static/img/import_success.4cce5c03.png";